import type { UpdateIntentRequest } from '@xpanse/ui';

import { useMutation } from '@tanstack/react-query';

import { IntentService } from 'src/utils/api';

export interface SingleIntentRequest {
  id: string;
  requestData: UpdateIntentRequest;
}

export type UserIntentRequest = SingleIntentRequest | SingleIntentRequest[];

/**
 * Updates a single intent
 */
const updateSingleIntent = async ({ id, requestData }: SingleIntentRequest) => {
  const response = await IntentService.updateIntent(id, requestData);
  return response;
};

/**
 * Updates multiple intents
 */
const updateMultipleIntents = async (requests: SingleIntentRequest[]) => {
  const updatePromises = requests.map((request) => updateSingleIntent(request));
  return Promise.all(updatePromises);
};

/**
 * Updates user intent(s) based on the input
 */
const updateUserIntent = async (data: UserIntentRequest) => {
  if (Array.isArray(data)) {
    return updateMultipleIntents(data);
  }
  return updateSingleIntent(data);
};

/**
 * React Query hook for updating a user intent or multiple intents
 */
export function useUpdateUserIntent() {
  const { mutate } = useMutation({
    mutationFn: updateUserIntent,
  });

  return { updateUserIntent: mutate };
}
